import React, { useState, useReducer } from 'react'

const About = () => {
    return (
        <>
            <div className="banner-image py-5">
                <img src="./restaurant/images/food-banner.jpeg" alt="" style={{ maxWidth: '100%' }} />
                <h1 className="pt-5 pb-3 fw-bold">About</h1>
                <div className="row">
                    <div className="col-12 col-md-8">
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam laboriosam velit repudiandae quasi necessitatibus adipisci quod ipsam possimus neque libero totam placeat rerum consequuntur voluptate quia minima, id perspiciatis magni! Doloribus laboriosam neque maiores aperiam, inventore reiciendis quis voluptatum facilis debitis tempore, culpa voluptas quam omnis ut delectus assumenda fuga!</p>
                        <h3 className="py-3">Sample Title</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. possimus neque libero totam placeat rerum consequuntur voluptate quia minima, id perspiciatis magni! Doloribus laboriosam neque maiores aperiam, inventore reiciendis quis voluptatum facilis debitis tempore, culpa voluptas quam omnis ut delectus assumenda fuga!</p>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam laboriosam velit repudiandae adipisci quod ipsam possimus neque libero totam placeat rerum consequuntur voluptate quia minima, id perspiciatis magni! Doloribus laboriosam neque maiores aperiam, inventore reiciendis quis voluptatum facilis debitis tempore, culpa voluptas quam omnis ut delectus assumenda fuga!</p>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam id perspiciatis magni! Doloribus laboriosam neque maiores aperiam, inventore reiciendis quis voluptatum facilis debitis tempore, culpa voluptas quam omnis ut delectus assumenda fuga!</p>
                    </div>
                    <div className="col-12 col-md-4">
                        {<UseState />}
                        <hr />
                        {<UseReduce />}
                    </div>
                </div>
            </div>
        </>
    )
}

const UseState = () => {
    let initialState = 0;
    const [currVal, setCurrVal] = useState(initialState)
    return (
        <>
            <div className="state-wrap mb-4">
                <h2 className="mb-3 text-primary">Nested Components (hooks)</h2>
                <hr />
                <h4>Basics of useState</h4>
                <p className="text-secondary">with ternary operator</p>
                <div className="value bg-warning w-50 p-1 text-center mb-3 fs-2">{currVal}</div>
                <button className="btn btn-primary me-3 btn-lg" onClick={() => { setCurrVal(currVal + 1) }}>INCR</button>
                <button className="btn btn-primary btn-lg" onClick={currVal > 0 ? () => { setCurrVal(currVal - 1) } : () => { setCurrVal(0) }}>DECR</button>
            </div>
        </>
    )
}

const reducer = (state, action) => {
    if (action.type === "INCR") {
        state = state + 1;
    }
    if (state > 0 && action.type === "DECR") {
        state = state - 1;
    }
    return state;
}

const UseReduce = () => {
    const initialDate = 0;
    const [state, dispatch] = useReducer(reducer, initialDate)
    return (
        <>
            <div className="reduce-wrap">
                <h4>Basics of useReducer</h4>
                <p className="text-secondary">same as above example with useReducer</p>
                <div className="value bg-warning w-50 p-1 text-center mb-3 fs-2">{state}</div>
                <button className="btn btn-primary me-3 btn-lg" onClick={() => dispatch({ type: "INCR" })}>INCR</button>
                <button className="btn btn-primary btn-lg" onClick={() => dispatch({ type: "DECR" })}>DECR</button>
            </div>
        </>
    )
}

export default About
